import { config, SupportedLocales } from "config";

export type IProductType = "PRODUCT";

export interface IProductImage {
    "id": number;
    "pluginId": number;
    "uri": string;
    "name": string;
    "language": string;
}

type IProductTextType = string;

export interface IProductText {
    "id": number;
    "pluginId": number;
    "type": IProductTextType;
    "description": any;
    "translations": IProductTranslation[];
    "textColor": string; // CSS color string
}

interface IProductTranslation {
    "id": number;
    "language": "DE" | "EN";
    "text": string; // html string
    "plainText": string; // plain text string
}

interface IProductTag {
    id: number;
    text: string;
}

interface IProductVideo {
    backgroundcolor: string;
    createdAt: number;
    createdBy: string;
    id: number;
    name: string;
    pluginId: number;
    tag: string;
    uri: string;
}

export interface IProductDetails {
    "id": number;
    "externalId": string;
    "keyVisual"?: IProductImage;
    "listImage"?: IProductImage;
    "xlImage"?: IProductImage;
    "detailsImage"?: IProductImage;
    "featured": boolean;
    "position": number;
    "inUse": boolean;
    "hidden": boolean;
    "type": IProductType;
    "texts": IProductText[];
    "categories": any[];
    "tags": IProductTag[];
    "images": IProductImage[];
    "videos": IProductVideo[];
    "ratings": any[];
    "comments": any[];
    "components": any[];
    "simage"?: IProductImage;
    "mimage"?: IProductImage;
    "limage"?: IProductImage;
}

export type ProductDetailsResponse = IProductDetails[];

export function productDetailsGetText(details: IProductDetails, type: IProductTextType, language: SupportedLocales, html = false) {
    const pluginText = details.texts.find(pt => pt.type === type);
    if (!pluginText) {
        return "";
    }

    let lang = language.toUpperCase();
    if (lang !== "EN" && lang !== "DE") {
        lang = config.DEFAULT_LANGUAGE.toUpperCase();
    }

    const translation = pluginText.translations.find(t => t.language === lang);
    if (!translation) {
        return "";
    }

    return html ? translation.text : translation.plainText;
}


// WEBPACK FOOTER //
// ./src/types/products.ts